import React from "react";
import { Nav } from "res-components/build/MainNav";
import ErrorBoundary from "components/ErrorBoundary";
import Header from "./Header/index";
import MobileNavbar from "./Header/MobileNavbar";
import muiTheme from '../../config/muiTheme';
import {ThemeProvider} from '@mui/material/styles';

export default ({ children }) => (
  <ThemeProvider theme={muiTheme}>
    <div className="layout-default">
      <Nav renderLinks={() => <MobileNavbar />} />
      <Header />
      <ErrorBoundary>{children}</ErrorBoundary>
    </div>
  </ThemeProvider>
);
